module.exports = __webpack_public_path__ + "img/352-31dbf8.png";